import React, { FunctionComponent } from "react";
import { ProofOperationDialogProps } from "./ProofOperationDialog";
import ProofOperationWrapper from "./ProofOperationWrapper";

export interface EditProofProps extends Omit<ProofOperationDialogProps, "isEditOperation"> {
}

const EditProof: FunctionComponent<EditProofProps> = (props) => {
	return (<ProofOperationWrapper isEditOperation {...props} />);
};

export default EditProof;